import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toolbar } from "primereact/toolbar";
import React, { useEffect, useRef, useState } from "react";
import { IPurchaseOrder, POStatus } from "../../models/PurchaseOrder";
import { Fetch, hrLenseBaseUrl } from "../../shared/Fetch";
import { EmptyFilterPurchase, Filter, IFilterPurchase } from "./Filter";
import { ILogin, IPermissionProps } from "../../models/Login";
import { Edit } from "./Edit";
import { APW } from "./APW";
import { RBilling } from "./RBilling";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Details } from "./details/Details";
import { format } from "date-fns";
import { InvoiceTable } from "../invoiceTracking/Table";
//import { Table as TimeSheetTable } from "../showTimesheet/Table";
import { ShowTimesheet } from "../showTimesheet";
import { Dialog } from "primereact/dialog";
import { GeneratePO } from "./GeneratePO";
import { CompanyDocumentUpload } from "./SendCompanyDetails";
import { CopyPo } from "./details/CopyPo";
import { Escalation } from "./Escalation";
import { safeFormatDate } from "../../models/DateFormatMapper";
import { User } from "../jvConnect/User";
import RateChangeForBandS from "./RateChangeForBandS";
import { LegalTask } from "./LegalTask";
import { Dropdown } from "primereact/dropdown";
import { Card } from "primereact/card";
import { POStatusMap } from "../../models/FDropdown";
import { OverlayPanel } from "primereact/overlaypanel";
import { Menu } from "primereact/menu";


interface Iprops {
  setReload: (reload: boolean) => void;
  toast: any;
  reload: boolean;
  permissions: IPermissionProps;
}

export const Table = (props: Iprops) => {
  const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IPurchaseOrder>; loading: boolean });
  const [filters, setFilters] = useState<IFilterPurchase>(EmptyFilterPurchase);
  const [invoiceLeft, setInvoiceLeft] = useState<number>(0);
  const [timesheetLeft, setTimesheetLeft] = useState<number>(0);
  const [consultantTimesheetLeft, setConsultantTimesheetLeft] = useState<number>(0);
  const [consultantInvoiceLeft, setConsultantInvoiceLeft] = useState<number>(0);
  const [rateChangeModal, setRateChangeModal] = useState({ open: false, po: {} as IPurchaseOrder });
  const [modal, setModal] = useState({ open: false, type: "", singleData: {} } as { open: boolean, type: string, singleData: IPurchaseOrder });
  const [legalModal, setLegalModal] = useState({ type: "" } as { type: string });
  const [modalForAvailability, setModalForAvailability] = useState({ open: false, type: "", singleData: {} } as { open: boolean, type: string, singleData: IPurchaseOrder });
  const [selectedRow, setSelectedRow] = useState<IPurchaseOrder | null>(null);
  const [openAction, setOpenAction] = useState<number | null>(null);
  const dt = useRef<any>(null);
  const toast = useRef<any>(null);

  // const [filter, setFilter] = useState(false);
  // const hideFilterDialog = () => {
  //     setFilter(false);
  // };

  let _roles: Array<number> = [];
  const loginObj: ILogin = JSON.parse(sessionStorage.getItem("auth") + "");
  loginObj.roles.forEach((role) => {
    _roles.push(role.role_ID);
  });

  const [edit, setEdit] = useState({ po: {}, open: false } as { po: IPurchaseOrder; open: boolean });
  const [details, setDetails] = useState({ po: {}, open: false } as { po: IPurchaseOrder; open: boolean });
  const [copypo, setCopyPo] = useState({ po: {}, open: false } as { po: IPurchaseOrder; open: boolean });

  const hideEditDialog = () => {
    setEdit({ po: {}, open: false });
  };
  const hideDetailsDialog = () => {
    setDetails({ po: {}, open: false });
    setCopyPo({ po: {}, open: false });
  };

  const [apw, setAPW] = useState({ po: {}, open: false } as { po: IPurchaseOrder; open: boolean });
  const hideAPWDialog = () => {
    setAPW({ po: {}, open: false });
  };
  const [rBilling, setRBilling] = useState({ po: {}, open: false } as { po: IPurchaseOrder; open: boolean });
  const [gInvoice, setGInvoice] = useState({ po: {}, open: false } as { po: IPurchaseOrder; open: boolean });
  const [timeSheet, setTimeSheet] = useState({ po: {}, open: false } as { po: IPurchaseOrder; open: boolean });
  const [modal2, setModal2] = useState({ singleData: {}, open: false } as { singleData: IPurchaseOrder; open: boolean });
  const [modal3, setModal3] = useState({ singleData: {}, open: false } as { singleData: IPurchaseOrder; open: boolean });
  const [openEscalation, setOpenEscalation] = useState({ po: {}, open: false } as { po: IPurchaseOrder; open: boolean });
  const [userModal, setUserModal] = useState({ open: false, data: null, type: null } as any);
  const [userModalData, setUserModalData] = useState({ data: null as { employeeId?: number; empCode?: string; phoneNumber?: string; whatsAppNumber?: string; personalEmail?: string } | null });
  const [reqModal, setreqModal] = useState({ open: false, data: null as any });
  const [expandedRows, setExpandedRows] = useState<Array<IPurchaseOrder>>([]);
  const [expandedActions, setExpandedActions] = useState<number[]>([]);
  const hideDialog2 = () => {
    setModal2({ singleData: {}, open: false });
    setModal3({ singleData: {}, open: false });
  };
  // const [showAction, setShowAction] = useState(0);

  const hideRBillingDialog = () => {
    setRBilling({ po: {}, open: false });
  };

  useEffect(() => {
    loadTableData();
  }, [filters, props.reload]);




  
  const exportCSV = () => {
    dt.current.exportCSV();
  };

  const loadTableData = async () => {
    setTableData({ tableData: tableData.tableData, loading: true });
    let externalUserFilter = "";
    if (_roles.includes(30) || _roles.includes(31)) {
      externalUserFilter = `&externalUser=${loginObj.id}`;
    }
    const response = await Fetch("vwPODetails", "GET", null, `filter=${encodeURIComponent(JSON.stringify(filters))}` + externalUserFilter, props.toast);
    if (response) {
      const data: Array<IPurchaseOrder> = await response.json();
      //   console.log("data Show Po", data)
      // const rawData: Array<{ po: IPurchaseOrder; sales_Team_Name: string | null; recruiter_Team_Name: string | null }> = await response.json();
      // const data: Array<IPurchaseOrder> = rawData.map((item) => ({
      //   ...item.po,
      //   sales_Team_Name: item.sales_Team_Name,
      //   recruiter_Team_Name: item.recruiter_Team_Name,
      // }));
      setTableData({ tableData: data, loading: false });
    }

    const response2 = await Fetch("vwPODetails/getTimesheetInvoiceLeft", "GET", null, `filter=${JSON.stringify(filters)}` + externalUserFilter, props.toast);
    if (response2) {
      const data: any = await response2.json();
      setInvoiceLeft(data.invoiceLeft);
      setTimesheetLeft(data.timesheetLeft);
      setConsultantTimesheetLeft(data.consultantTimesheetLeft);
      setConsultantInvoiceLeft(data.consultantInvoiceLeft);
    }
  };

  const rightToolbarTemplate = () => {
    return props.permissions.is_Export ? (
      <React.Fragment>
        {(_roles.includes(20) || _roles.includes(1) || _roles.includes(30) || _roles.includes(31)) && (
          <div className="flex align-items-center justify-content-center">
            <div>
              {invoiceLeft !== 0 && (
                <h1 className="text-xl font-bold mr-5">
                  Pending Invoices : <span style={{ color: "red" }}>{invoiceLeft}</span>
                </h1>
              )}
            </div>
            <div>
              {consultantInvoiceLeft !== 0 && (
                <h1 className="text-xl font-bold mr-5">
                  No. Of Consultants Whose Invoices are Pending : <span style={{ color: "red" }}>{consultantInvoiceLeft}</span>
                </h1>
              )}
            </div>
            <div>
              {timesheetLeft !== 0 && (
                <h1 className="text-xl font-bold mr-5">
                  Pending Timesheets : <span style={{ color: "red" }}>{timesheetLeft}</span>
                </h1>
              )}
            </div>
            <div>
              {consultantTimesheetLeft !== 0 && (
                <h1 className="text-xl font-bold mr-5">
                  No. Of Consultants Whose Timesheets are Pending : <span style={{ color: "red" }}>{consultantTimesheetLeft}</span>
                </h1>
              )}
            </div>
          </div>
        )}
        <Button label="Export" icon="pi pi-upload" className="p-button-help" onClick={exportCSV} />
      </React.Fragment>
    ) : (
      (_roles.includes(20) || _roles.includes(1) || _roles.includes(30) || _roles.includes(31)) && (
        <div className="flex align-items-center justify-content-center">
          <div>
            {invoiceLeft !== 0 && (
              <h1 className="text-4xl font-bold mr-5">
                Pending Invoices : <span style={{ color: "red" }}>{invoiceLeft}</span>
              </h1>
            )}
          </div>
          <div>
            {timesheetLeft !== 0 && (
              <h1 className="text-4xl font-bold mr-5">
                Pending Timesheets : <span style={{ color: "red" }}>{timesheetLeft}</span>
              </h1>
            )}
          </div>
        </div>
      )
    );
  };

  const header = (
    <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
      <h5 className="m-0">Purchase Order</h5>
      {/* <span className="block mt-2 md:mt-0 p-input-icon-left">
                <Button icon="pi pi-filter" onClick={() => setFilter(true)} className="p-button-rounded p-button-secondary ml-2" aria-label="Filter" />
            </span> */}
    </div>
  );

  const consultant_Name = (rowData: IPurchaseOrder) => {
    return (
      <span
        onClick={() => {
          if (props.permissions.is_Update && !(_roles.includes(30) || _roles.includes(31) || _roles.includes(40))) setDetails({ po: rowData, open: true });
        }}
        className={props.permissions.is_Update && !_roles.includes(40) ? "cursor-pointer text-cyan-700 underline" : ""}
      >
        {rowData.consultant_Name}
      </span>
    );
  };
  const pO_Status = (rowData: IPurchaseOrder) => {
    return props.permissions.is_Update ? (
      <span
        onClick={() => {
          if (props.permissions.is_Update && !(_roles.includes(30) || _roles.includes(31) || _roles.includes(40))) setEdit({ po: rowData, open: true });
        }}
        className={props.permissions.is_Update && !_roles.includes(40) ? "cursor-pointer text-cyan-700 underline" : ""}
      >
        {rowData.pO_Status ? rowData.pO_Status_Name : ''}
      </span>
    ) : (
      <span>{rowData.pO_Status ? rowData.pO_Status_Name : ''}</span>
    );
  };
  // const actionBodyTemplate = (rowData: IPurchaseOrder) => {
  //   return props.permissions.is_Update ? (
  //     <>
  //       <div
  //         style={{
  //           display: "flex",
  //           flexDirection: "column",

  //         }}
  //       >
  //         {(_roles.includes(1) || _roles.includes(20) || _roles.includes(38)) && (
  //           <Button
  //             label="APW"
  //             className="p-button-rounded p-button-info p-button-text"
  //             onClick={() => {
  //               if (rowData.pO_ID) setAPW({ po: rowData, open: true });
  //             }}
  //           />
  //         )}
  //         {!(_roles.includes(30) || (_roles.includes(31) && _roles.includes(38))) && (
  //           <Button
  //             label="RBilling"
  //             className="p-button-rounded p-button-info p-button-text"
  //             onClick={() => {
  //               if (rowData.pO_ID) setRBilling({ po: rowData, open: true });
  //             }}
  //           />
  //         )}
  //         {(_roles.includes(42) || _roles.includes(1) || _roles.includes(38)) && (
  //           <Button
  //             label="Invoice"
  //             tooltip="Add Invoice"
  //             className="p-button-rounded p-button-info p-button-text"
  //             onClick={() => {
  //               if (rowData.pO_ID) setGInvoice({ po: rowData, open: true });
  //             }}
  //           />
  //         )}
  //         {(_roles.includes(44) || _roles.includes(1) || _roles.includes(38)) && (
  //           <Button
  //             label="TimeSheet"
  //             tooltip="Add TimeSheet"
  //             className="p-button-rounded p-button-info p-button-text"
  //             onClick={() => {
  //               if (rowData.pO_ID) setTimeSheet({ po: rowData, open: true });
  //             }}
  //           />
  //         )}
  //         <Button
  //           label="Generte PO"
  //           tooltip="Generate PO"
  //           className="p-button-rounded p-button-info p-button-text"
  //           onClick={() => {
  //             openGeneratePO(rowData);
  //           }}
  //         />
  //         {rowData.sV_Referals === true && rowData.pV_Referal && (
  //           <Button
  //             label="Copy PO"
  //             tooltip="Copy PO"
  //             className="p-button-rounded p-button-info p-button-text"
  //             onClick={() => {
  //               setCopyPo({ po: rowData, open: true });
  //             }}
  //           />
  //         )}
  //         {/* <Button icon="pi pi-envelope" className="p-button-rounded  p-button-text ml-2" onClick={() => openSendComapnyDetails(rowData)} tooltip="Upload Document" /> */}
  //         {(_roles.includes(1) || _roles.includes(4) || _roles.includes(5) || _roles.includes(20)) && (
  //           <Button
  //             label="Escalation"
  //             tooltip="Add Escalation"
  //             className="p-button-rounded p-button-info p-button-text"
  //             onClick={() => {
  //               if (rowData.pO_ID) setOpenEscalation({ po: rowData, open: true });
  //             }}
  //           />
  //         )}
  //       </div>
  //     </>
  //   ) : _roles.includes(1) || _roles.includes(4) || _roles.includes(5) || _roles.includes(20) ? (
  //     <Button
  //       label="Escalation"
  //       tooltip="Add Escalation"
  //       className="p-button-rounded p-button-info p-button-text"
  //       onClick={() => {
  //         if (rowData.pO_ID) setOpenEscalation({ po: rowData, open: true });
  //       }}
  //     />
  //   ) : (
  //     ""
  //   );
  // };


const actionBodyTemplate = (rowData: IPurchaseOrder) => {
  
  const items = [];

  if (_roles.includes(1) || _roles.includes(20) || _roles.includes(38)) {
    items.push({
      label: "APW",
      command: () => {
        if (rowData.pO_ID) {
          setAPW({ po: rowData, open: true });
        }
      },
    });
  }

  if (!(_roles.includes(30) || (_roles.includes(31) && _roles.includes(38)))) {
    items.push({
      label: "RBilling",
      command: () => {
        if (rowData.pO_ID) {
          setRBilling({ po: rowData, open: true });
        }
      },
    });
  }

  if (_roles.includes(42) || _roles.includes(1) || _roles.includes(38)) {
    items.push({
      label: "Invoice",
      command: () => {
        if (rowData.pO_ID) {
          setGInvoice({ po: rowData, open: true });
        }
      },
    });
  }

  if (_roles.includes(44) || _roles.includes(1) || _roles.includes(38)) {
    items.push({
      label: "TimeSheet",
      command: () => {
        if (rowData.pO_ID) {
          setTimeSheet({ po: rowData, open: true });
        }
      },
    });
  }

  items.push({
    label: "Generate PO",
    command: () => {
      openGeneratePO(rowData);
    },
  });

  if (rowData.sV_Referals === true && rowData.pV_Referal) {
    items.push({
      label: "Copy PO",
      command: () => {
        setCopyPo({ po: rowData, open: true });
      },
    });
  }

  if (_roles.includes(1) || _roles.includes(4) || _roles.includes(5) || _roles.includes(20)) {
    items.push({
      label: "Escalation",
      command: () => {
        if (rowData.pO_ID) {
          setOpenEscalation({
            po: rowData,
            open: true,
          });
        }
      },
    });
  }

 return <Menus items={items} />;
};
  // const sendCompanyDetail = (rowData: IPurchaseOrder) => {
  //   return (
  //     <>
  //       <span className="text-cyan-700 underline" style={{ cursor: "pointer" }} onClick={() => openSendComapnyDetails(rowData)}>
  //         {" "}
  //         Send Email
  //       </span>
  //     </>
  //   );
  // };

  const onHide = () => {
    setGInvoice({ po: {}, open: false });
    setTimeSheet({ po: {}, open: false });
  };

  const openGeneratePO = (rowData: IPurchaseOrder) => {
    setModal2({ open: true, singleData: rowData });
  };
  // const openSendComapnyDetails = (rowData: IPurchaseOrder) => {
  //   setModal3({ open: true, singleData: rowData });
  // };
  // const getEmployeeDetails = async (empCode: string) => {
  //   const response = await fetch(`${hrLenseBaseUrl}/Tds_Slab/getempbycode?empCode=${empCode}`, { method: "GET" });
  //   if (response) {
  //     const data: { employeeId?: number; empCode?: string; phoneNumber?: string; whatsAppNumber?: string; personalEmail?: string } = await response.json();
  //     setUserModalData({ data });
  //   }
  // };

  const DateFormat = loginObj?.date_Format;

  const b_Rate_Change = (rowData: IPurchaseOrder) => {
    const isAllowedRole = _roles.includes(3) || _roles.includes(4) || _roles.includes(21);
    const isToJoined = rowData.pO_Status === POStatus.To_Join;

    return (
      <span
        className={isAllowedRole && isToJoined ? "cursor-pointer text-cyan-700 underline" : ""}
        onClick={() => {
          if (isAllowedRole && isToJoined) {
            setRateChangeModal({ open: true, po: rowData });
          }
        }}
      >
        {rowData.bRate}
      </span>
    );
  };

  const s_Rate_Change = (rowData: IPurchaseOrder) => {
    const isAllowedRole = _roles.includes(2) || _roles.includes(5);
    const isToJoined = rowData.pO_Status === POStatus.To_Join;
    return (
      <span
        className={isAllowedRole && isToJoined ? "cursor-pointer text-cyan-700 underline" : ""}
        onClick={() => {
          if (isAllowedRole && isToJoined) {
            setRateChangeModal({ open: true, po: rowData });
          }
        }}
      >
        {rowData.sRate}
      </span>
    );
  };

  const legalTask = (rowData: IPurchaseOrder) => {
    const labelTask: string = `Task ( ${rowData?.tasks_Count ?? 0} )`;
    return (
      (<div className="flex">
        {(rowData?.parent_PO_ID !== undefined && rowData?.parent_PO_ID !== null && rowData?.parent_PO_ID > 0) ? ((_roles.includes(1) || _roles.includes(26) || _roles.includes(8) || _roles.includes(16) || _roles.includes(18) || _roles.includes(33)) && (<div className="flex gap-3">
          <Button
            label={labelTask}
            tooltip="Create Task For Client Documents"
            className="p-button-rounded p-button-info p-button-text"
            style={{ width: "8rem" }}
            onClick={() => {
              if (rowData.pO_ID) {
                if (_roles.includes(1) || _roles.includes(26) || _roles.includes(8) || _roles.includes(16) || _roles.includes(18)) setModal({ open: true, type: "Client", singleData: rowData });
              }
            }}
          />
        </div>)) : (_roles.includes(1) || _roles.includes(26) || _roles.includes(11) || _roles.includes(2) || _roles.includes(3) || _roles.includes(4) || _roles.includes(5)) && (<div className="flex gap-3">
          <Button
            label={labelTask}
            tooltip="Create Task For Client Documents"
            className="p-button-rounded p-button-info p-button-text"
            style={{ width: "8rem" }}
            onClick={() => {
              if (rowData.pO_ID) {
                if (_roles.includes(2) || _roles.includes(5)) setLegalModal(prev => prev = { type: "Client" });
                else if (_roles.includes(3) || _roles.includes(4)) setLegalModal(prev => prev = { type: "Vendor" });
                else setLegalModal(prev => prev = { type: "" });
                setModal({ open: true, type: "Client", singleData: rowData });
              }
            }}
          />
        </div>)}

        {/* {(_roles.includes(1) || _roles.includes(26) || _roles.includes(2) || _roles.includes(5) || _roles.includes(11)) && (
          <div className="flex gap-3">
            <Button
              label="Create Task"
              tooltip="Create Task For Client Documents"
              className="p-button-rounded p-button-info p-button-text"
              style={{ width: "8rem" }}
              onClick={() => {
                if (rowData.pO_ID) setModal({ open: true, type: "Client", singleData: rowData });
              }}
            />
          </div>
        )}
        {(_roles.includes(1) || _roles.includes(26) || _roles.includes(3) || _roles.includes(4) || _roles.includes(11)) && (
          <div className="flex gap-3">
            <Button
              label="Create Task"
              tooltip="Create Task For Vendor Documents"
              className="p-button-rounded p-button-info p-button-text"
              style={{ width: "8rem" }}
              onClick={() => {
                if (rowData.pO_ID) setModal({ open: true, type: "Vendor", singleData: rowData });
              }}
            />
          </div>
        )} */}
      </div>)
    );
  };

  const rowExpansionTemplate = (data: IPurchaseOrder) => {
    return <></>;
    // return <LegalTask open={true} hideDialog={() => setModal({ open: false, singleData: {} })} pO_ID={data.pO_ID || 0} toast={props.toast} />;
  }

  const allowExpansion = (rowData: IPurchaseOrder) => {
    return (rowData.pO_ID !== undefined && rowData.pO_ID !== null && rowData.pO_ID > 0);
  };

  const handleMarketingToggle = async (rowData: IPurchaseOrder) => {
    const newValue = !(rowData.marketing_Availability || false);
    const response = await Fetch("Consultant_Mast/UpdateMarketingAvailability", "POST", { Consultant_ID: rowData.consultant_ID, Marketing_Availibility: newValue }, "", props.toast);
    if (response) {
      props.toast.current.show({ severity: "success", content: "Marketing Availability Updated Successfully." });
      loadTableData();
      setModalForAvailability({ open: false, type: "", singleData: {} });
    }
  };

  return (
    <>
      <Toolbar className="mb-1 py-0" right={rightToolbarTemplate}></Toolbar>
      <Accordion>
        <AccordionTab header="Filter">
          <Filter filters={filters} setFilters={(filters: IFilterPurchase) => setFilters(filters)} />
        </AccordionTab>
      </Accordion>
      <div style={{ height: "500px", overflow: "visible" }}>
      <DataTable
        ref={dt}
        size="small"
        stripedRows
        showGridlines
        scrollable
        scrollHeight="100vh"
        responsiveLayout="scroll"
        style={{ border: "1px solid rgba(105,105,105,0.17)", borderTopWidth: "0", marginTop: "5px" }}
        exportFilename={format(new Date(), "dd-MM-yyyy hh_mm_ss a").toUpperCase()}
        value={tableData.tableData}
        header={header}
        loading={tableData.loading}
        
      >
        {/* <DataTable
        style={{ border: "1px solid rgba(105,105,105,0.17)", borderTopWidth: "0", marginTop: "5px" }}
        ref={dt}
        size="small"
        stripedRows
        showGridlines
        responsiveLayout="scroll"
        exportFilename={format(new Date(), "dd-MM-yyyy hh_mm_ss a").toUpperCase()}
        value={tableData.tableData}
        header={header}
        loading={tableData.loading}
        scrollable
        scrollHeight="500px"
       expandedRows={expandedRows}
       onRowToggle={(e: any) => setExpandedRows(e.data)}
       rowExpansionTemplate={rowExpansionTemplate}
      > */}
        <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} style={{ minWidth: '100px',  wordBreak: "break-word" }} />
        <Column field="company_Name_Sales" header="Company Name" style={{ minWidth: '180px',  wordBreak: "break-word" }} />
        {/* <Column field="salesmanager" header="Sales Manager" body={(rowData) => <p style={{ color: rowData.sales_Status ? "red" : "" }}>{rowData.salesmanager}</p>} /> */}
        <Column
          field="salesmanager"
          header="Sales Manager"
          sortable style={{ minWidth: '180px',  wordBreak: "break-word" }}
          body={(r: IPurchaseOrder) => {
            const showInfo = r?.recruiter_ID === loginObj.id || r?.sales_ID === loginObj.id;
            return (
              <User
                req={{
                  reqId: r.req_ID!,
                  jobTitle: r.req_Job_Title ?? "",
                  postedDate: r.pO_Date?.toString() ?? "",
                  userId: r.sales_ID ?? 0,
                  userName: r.salesmanager ?? "",
                }}
                show={showInfo}
              />
            );
          }}
        />

        <Column field="sales_Team_Name" header="Sales Manager Team" body={(rowData: any) => rowData?.sales_Team_Name} style={{ minWidth: '180px',  wordBreak: "break-word" }} />
        <Column field="sales_Company_Branch" header="Sales Comp (Branch)" sortable style={{ minWidth: '180px',  wordBreak: "break-word" }} />
        {/* <Column field="user_Name" header="Recruiter" body={(rowData) => <p style={{ color: rowData.recruiter_Status ? "red" : "" }}>{rowData.user_Name}</p>} /> */}
        <Column
          field="user_Name"
          header="Recruiter"
          sortable style={{ minWidth: '180px',  wordBreak: "break-word" }}
          body={(r: IPurchaseOrder) => {
            const showInfo = r?.recruiter_ID === loginObj.id || r?.sales_ID === loginObj.id;
            return (
              <User
                req={{
                  reqId: r.req_ID!,
                  jobTitle: r.req_Job_Title ?? "",
                  postedDate: r.pO_Date?.toString() ?? "",
                  userId: r.recruiter_ID ?? 0,
                  userName: r.user_Name ?? "",
                }}
                show={showInfo}
              />
            );
          }}
        />
        <Column field="recruiter_Team_Name" header="Recruiter Person Team" body={(rowData: any) => rowData?.recruiter_Team_Name} style={{ minWidth: '180px',  wordBreak: "break-word" }} />
        <Column field="recruiter_Company_Branch" header="Recruiter Comp (Branch)" sortable style={{ minWidth: '180px',  wordBreak: "break-word" }} />
        <Column field="consultant_Name" header="Consultant Name" body={consultant_Name} style={{ minWidth: '180px',  wordBreak: "break-word" }} />
        <Column field="marketing_Availability" style={{ minWidth: '180px' }} header="Consultant Availability" body={(rowData: IPurchaseOrder) => {
          if ((_roles.includes(1) || _roles.includes(11) || _roles.includes(26)))
            return <p className="cursor-pointer text-cyan-700 underline" onClick={() => setModalForAvailability({ open: true, type: "", singleData: rowData })}>{rowData.marketing_Availability === true ? "Yes" : "No"}</p>;
          else return <p>{rowData.marketing_Availability === true ? "Yes" : "No"}</p>;
        }} />
        {!(_roles.includes(30) || _roles.includes(31)) && <Column field="req_CategoryName" header="Skill Category" style={{ minWidth: '180px',  wordBreak: "break-word" }} />}
        {!(_roles.includes(3) || _roles.includes(4) || _roles.includes(21) || _roles.includes(19)) && <Column field="project_Client_Name" header="End Client" style={{ minWidth: '180px',  wordBreak: "break-word" }} />}
        {/* {!(_roles.includes(30) || _roles.includes(31)) && <Column field="project_Start_Date1" header="Start Date" />} */}
        {!(_roles.includes(30) || _roles.includes(31)) && <Column field="project_Start_Date1" header="Start Date" style={{ minWidth: "100px" }} body={(rowData: any) => safeFormatDate(rowData.project_Start_Date1, "dd/MM/yyyy", DateFormat)} />}
        {!(_roles.includes(30) || _roles.includes(31)) && <Column field="bRate" header="B Rate" body={b_Rate_Change} style={{ minWidth: '120px' }} />}
        {!(_roles.includes(30) || _roles.includes(31)) && <Column field="sRate" header="S Rate" body={s_Rate_Change} style={{ minWidth: '120px' }} />}
        {!(_roles.includes(30) || _roles.includes(31)) && <Column field="mRate" header="Margin " style={{ minWidth: '120px' }} />}
        {!(_roles.includes(3) || _roles.includes(4) || _roles.includes(21) || _roles.includes(40) || _roles.includes(19)) && <Column field="vendor_Company_Name" header="Vendor Company" style={{ minWidth: '180px',  wordBreak: "break-word" }} />}
        {!(_roles.includes(30) || _roles.includes(31) || _roles.includes(19)) && <Column header="Sub Vendor" style={{ minWidth: '180px',  wordBreak: "break-word" }} body={(e) => (e.pO_Sub_Vendor_Company !== null ? <p>{e.pO_Sub_Vendor_Company}</p> : <p>{e.sub_Vendor_Company}</p>)} />}
        {/* {!(_roles.includes(30) || _roles.includes(31)) && <Column field="pO_Date1" header="PO Date" />} */}
        {!(_roles.includes(30) || _roles.includes(31)) && <Column field="pO_Date1" header="PO Date" style={{ minWidth: "100px" }} body={(rowData: any) => safeFormatDate(rowData.pO_Date1, "dd/MM/yyyy", DateFormat)} />}
        {!(_roles.includes(30) || _roles.includes(31)) && <Column field="pO_Status_Name" header="Status" body={pO_Status} style={{ minWidth: "100px" }}/>}
        {!(_roles.includes(30) || _roles.includes(31)) && <Column field="referred_By" header="Referred By" />}
        {/* {(_roles.includes(1)) && <Column field="" header="Send Mail" body={sendCompanyDetail} />} */}
        {/* {(_roles.includes(1) || _roles.includes(26) || _roles.includes(2) || _roles.includes(3) || _roles.includes(4) || _roles.includes(5) || _roles.includes(11)) && <Column header="Legal Task" expander={allowExpansion} />} */}
        {(_roles.includes(1) || _roles.includes(26) || _roles.includes(2) || _roles.includes(3) || _roles.includes(4) || _roles.includes(5) || _roles.includes(11) || _roles.includes(8) || _roles.includes(16) || _roles.includes(18)) && <Column header="Legal Task" style={{ minWidth: '180px' }} body={(rowData: IPurchaseOrder) => legalTask(rowData)} />}
        {(props.permissions.is_Update || _roles.includes(44) || _roles.includes(42) || _roles.includes(1) || _roles.includes(4) || _roles.includes(5) || _roles.includes(20)) && !_roles.includes(40) && <Column header="Action" style={{ minWidth: '180px' }} body={actionBodyTemplate} />}
      </DataTable>
      </div>
      {/* <Dialog visible={userModal.open} onHide={() => {
                setUserModal({ open: false, data: null, type: null });
                setUserModalData({ data: null });
            }} header="sales manager Details"  modal style={{ width: "30vw" }} > */}
      <Dialog
        visible={userModal.open}
        onHide={() => {
          setUserModal({ open: false, data: null, type: null });
          setUserModalData({ data: null });
        }}
        header={`${userModal?.type || "User"} Details`}
        modal
        style={{ width: "30vw" }}
      >
        {userModal.data && (
          <div className="p-fluid">
            <div className="border-round surface-card p-4 shadow-2">
              <div className="flex align-items-center mb-4">
                {" "}
                <i className="pi pi-user text-primary text-xl mr-3" />{" "}
                <div>
                  <div className="text-900 font-semibold text-lg">{userModal?.data?.name}</div>
                  <div className="text-600 text-sm"> {userModal?.type} </div>
                </div>
              </div>
              <div className="grid">
                <div className="col-12 flex align-items-center mb-3">
                  <i className="pi pi-envelope text-primary mr-3" />
                  <div>
                    <div className="text-600 text-sm">Professional Email</div>
                    <div className="text-900 font-medium"> {userModal?.data?.email} </div>
                  </div>
                </div>
                {userModalData?.data?.personalEmail && (
                  <div className="col-12 flex align-items-center mb-3">
                    <i className="pi pi-envelope text-primary mr-3" />
                    <div>
                      <div className="text-600 text-sm">Email/Hangout</div>
                      <div className="text-900 font-medium"> {userModalData?.data?.personalEmail} </div>
                    </div>
                  </div>
                )}
                {userModalData?.data?.phoneNumber && (
                  <div className="col-12 flex align-items-center mb-3">
                    <i className="pi pi-phone text-primary mr-3" />
                    <div>
                      <div className="text-600 text-sm">Phone</div>
                      <div className="text-900 font-medium"> {userModalData?.data?.phoneNumber} </div>
                    </div>
                  </div>
                )}
                {userModalData?.data?.whatsAppNumber && (
                  <div className="col-12 flex align-items-center mb-3">
                    <i className="pi pi-phone text-primary mr-3" />
                    <div>
                      <div className="text-600 text-sm">WhatsApp</div>
                      <div className="text-900 font-medium"> {userModalData?.data?.whatsAppNumber} </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </Dialog>
      <Edit open={edit.open} hideDialog={hideEditDialog} po={edit.po} toast={props.toast} reload={props.reload} setReload={props.setReload} />
      <APW open={apw.open} hideDialog={hideAPWDialog} po={apw.po} toast={props.toast} />
      <RBilling open={rBilling.open} hideDialog={hideRBillingDialog} po={rBilling.po} toast={props.toast} />
      {/* <Filter hideDialog={hideFilterDialog} open={filter} toast={props.toast} setFilters={(filters: IFilterPurchase | null) => setFilters(filters)} /> */}
      <Details open={details.open} hideDialog={hideDetailsDialog} po={details.po} toast={props.toast} reload={props.reload} setReload={props.setReload}></Details>
      <CopyPo open={copypo.open} hideDialog={hideDetailsDialog} po={copypo.po} toast={props.toast} reload={props.reload} setReload={props.setReload}></CopyPo>

      <Dialog visible={gInvoice.open} style={{ width: "80vw" }} header="Add/Update Invoice" className="p-fluid" onHide={onHide}>
        <InvoiceTable toast={props.toast} permissions={props.permissions} po={gInvoice.po} />
      </Dialog>
      <Dialog visible={timeSheet.open} style={{ width: "80vw" }} header="Add/Update TimeSheet" className="p-fluid" onHide={onHide}>
        <ShowTimesheet is_Create={props.permissions.is_Create} is_Delete={props.permissions.is_Delete} is_Update={(_roles.includes(59) || props.permissions.is_Update)} is_Export={props.permissions.is_Export} is_View={props.permissions.is_View} po={timeSheet.po} />
      </Dialog>
      <GeneratePO singleData={modal2.singleData} open={modal2.open} hideDialog={hideDialog2} toast={props.toast}></GeneratePO>
      <CompanyDocumentUpload singleData={modal3.singleData} open={modal3.open} hideDialog={hideDialog2} toast={props.toast} />
      <Escalation open={openEscalation.open} po={openEscalation.po} hideDialog={() => setOpenEscalation({ open: false, po: {} })} toast={props.toast} />
      <Dialog visible={rateChangeModal.open} style={{ width: "50vw" }} header="Rate Change Request" className="p-fluid" onHide={() => setRateChangeModal({ open: false, po: {} as IPurchaseOrder })}>
        <RateChangeForBandS
          po={rateChangeModal.po}
          toast={props.toast}
          onSave={() => {
            setRateChangeModal({ open: false, po: {} as IPurchaseOrder });
            props.setReload(!props.reload);
          }}
          onCancel={() => setRateChangeModal({ open: false, po: {} as IPurchaseOrder })}
        />
      </Dialog>
      <Dialog visible={modal.open} style={{ width: "80vw" }} header="Create Task" className="p-fluid" onHide={() => {
        setModal({ open: false, type: "", singleData: {} });
        setLegalModal({ type: "" });
      }}>
        {modal.singleData && (
          <DataTable value={[modal.singleData]} className="mb-3" showGridlines size="small" scrollable scrollHeight="500px">
            <Column field="company_Name_Sales" header="Company Name" />
            <Column field="salesmanager" header="Sales Manager" />
            <Column field="sales_Company_Branch" header="Sales Comp (Branch)" />
            <Column field="user_Name" header="Recuriter" />
            <Column field="recruiter_Company_Branch" header="Recruiter Comp (Branch)" />
            <Column field="consultant_Name" header="Consultant" />
            <Column field="company_Name_Sales" header="Company" />
            <Column field="pO_Status" header="Status" body={r => r.pO_Status ? POStatusMap[r.pO_Status] : ''} />
            <Column field="pO_Date1" header="PO Date" style={{ minWidth: "100px" }} body={(rowData: any) => safeFormatDate(rowData.pO_Date1, "dd/MM/yyyy", DateFormat)} />
            <Column header="Start Date" body={(rowData: any) => safeFormatDate(rowData.project_Start_Date1, "dd/MM/yyyy", DateFormat)} />
            <Column header="End Date" body={(rowData: any) => safeFormatDate(rowData.project_End_Date, "dd/MM/yyyy", DateFormat)} />

          </DataTable>
        )}
        {/* <div>
          <label>Create Task For Document Type</label>
          <Dropdown value={legalModal.type} onChange={(e) => setLegalModal({ type: e.value })} options={[{ name: "--Select--" }, { name: "Client" }, { name: "Vendor" }, { name: "Consultant" }]} optionLabel="name" optionValue="name" placeholder="Select a Document Type" className="w-full md:w-14rem"
          // disabled={(_roles.includes(2) || _roles.includes(3) || _roles.includes(4) || _roles.includes(5))}
          />
        </div> */}
        <div className="mt-2"></div>
        <LegalTask sourceType="PO" open={modal.open} type={legalModal.type} hideDialog={() => setModal({ open: false, type: "", singleData: {} })} pO_ID={modal.singleData.pO_ID || 0} toast={props.toast} is_form={false} hideDialogAb={() => { }} />
        {/* {legalModal.type.trim() !== "" && legalModal.type.trim() !== "--Select--" &&
          <LegalTask sourceType="PO" open={modal.open} type={legalModal.type} hideDialog={() => setModal({ open: false, type: "", singleData: {} })} pO_ID={modal.singleData.pO_ID || 0} toast={props.toast} is_form={false} hideDialogAb={() => { }} />
        } */}
      </Dialog>
      <Dialog visible={modalForAvailability.open} style={{ width: "30vw" }} header="Update Consultant Marketing Availability" className="p-fluid" onHide={() => {
        setModalForAvailability({ open: false, type: "", singleData: {} });
      }}>
        <Card>Are you sure you want to change the consultant's marketing availability from <b>{modalForAvailability?.singleData?.marketing_Availability === true ? "Yes" : "No"}</b> to <b>{modalForAvailability?.singleData?.marketing_Availability === true ? "No" : "Yes"}</b> ?</Card>
        <div className="field col-12 flex justify-content-end gap-2 mt-2">
          <Button label="Yes" onClick={() => handleMarketingToggle(modalForAvailability.singleData)} icon="pi pi-check" type="button" />
          <Button label="No" icon="pi pi-times" type="button" className="p-button-secondary" onClick={() => setModalForAvailability({ open: false, type: "", singleData: {} })} />
        </div>
      </Dialog>
    </>
  );
};

const Menus = ({ items }: { items: any[] }) => {
    const menu = useRef<Menu>(null);

    return (
        <div>
            <Menu
                model={items}
                popup
                ref={menu}
            />

            <Button
                icon="pi pi-ellipsis-v"
                className="p-button-text p-button-rounded"
                onClick={(event) => {
                    menu.current?.toggle(event);
                }}
            />
        </div>
    );
};
